export default "__VITE_ASSET__D_mYdjt7__"